module.exports = __webpack_public_path__ + "6936d228c8e867acd1c0553670b77943.ttf";


//////////////////
// WEBPACK FOOTER
// ./App/assets/camunda/fonts/bpmn.ttf
// module id = 306
// module chunks = 0